module.exports = require('./convert')(
  "=\"#&'()*+-/:;<>?@[\\]^_`yz{|}~§±",
  "´Ä§/ä)=(`ß-Öö;:_\"ü#+&?<zyÜ'*>^°"
)
